/**
 * The custom-session wizard's length choice: 10 · 20 · 50 · No limit.
 *
 * One choice, so the app's segmented control - it was four separate buttons
 * whose selected one was only a shade of indigo text, not the primary fill
 * every other single choice in the app uses.
 */

import { SegmentedControl } from '@ai-tutor/ui';
import { LENGTH_OPTIONS } from '@/lib/practice/wizardSteps';

type Length = number | 'all';

const OPTIONS = [
  ...LENGTH_OPTIONS.map(n => ({ value: String(n), label: `${n} concepts` })),
  { value: 'all', label: 'No limit' },
];

export function WizardLengthStep({
  length,
  onChange,
}: {
  length: Length;
  onChange: (length: Length) => void;
}) {
  return (
    <>
      <SegmentedControl
        label='Session length'
        options={OPTIONS}
        value={String(length)}
        onChange={v => onChange(v === 'all' ? 'all' : Number(v))}
        className='flex w-full'
        segmentClassName='tap-target flex-1 max-sm:px-1'
      />
      <p className='mt-3 text-sm text-muted-foreground'>
        {length === 'all'
          ? 'Practices every concept that matches your filters - no cap.'
          : `Caps the session at ${length} concept${length === 1 ? '' : 's'}.`}
      </p>
    </>
  );
}
